import { useFullRelease } from "@/common/hooks_useFullRelease";
import ChangeHistoryModal from "@/components/changeHistory/ChangeHistoryModal";
import { useDialogModal } from "@/ui/dialogs/useDialogModal";
import Button from "@imminently/decisively-ui/Button";
import Icon from "@imminently/decisively-ui/Icon";
import { useTranslation } from "react-i18next";

export const ReleaseChangeHistoryButton = () => {
  const { openDialogModal } = useDialogModal();
  const { t } = useTranslation();
  const release = useFullRelease();

  if (!release) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openDialogModal(
      {
        title: t("build.change_history"),
        maxWidth: false,
      },
      <ChangeHistoryModal release={release} />,
    );
  };

  return (
    <Button
      icon
      label={t("build.change_history")}
      size="md"
      className="p-1"
      onClick={handleClick}
    >
      <Icon name="history" />
    </Button>
  );
};
